import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Terms.css";
import Preheader from "../KalHome/Preheader";
import Header from "../KalHome/Header";
import Footer from "../Homecomponents/Footer";
import Superheader from "../KalHome/Superheader";

const TermsAndConditionsPage = () => {
  const [fetchedData, setFetchedData] = useState([]);
    const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Home_PrivacyPolicy"
      );
      console.log(response.data);
      setFetchedData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>

      <div className="terms-container py-5">
        <div className="container">
          <h1 className="text-center mb-4">Terms and Conditions</h1>
          <p className="text-muted text-center mb-5">
            Please read these terms and conditions carefully before using our
            website.
          </p>
          {fetchedData?.map((item) => (
            <>
              <div className="terms-section mb-4">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </>
          ))}

          <div className="text-center mt-5">
            <p className="text-muted">
              If you have any questions regarding our terms, feel free to{" "}
              <a href="/contactus" className="terms-link">
                contact us
              </a>
              .
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditionsPage;
